/* eslint-disable quotes */
/* eslint-disable no-useless-escape */
/* eslint-disable no-sparse-arrays */
// Alemão
export const alemao = {
  start: "Starten",
  save: "Speichern",
  delete: "Löschen",
  update: "Aktualisieren",
  lets: "Lass uns spielen",
  permanentbuy: "Dauerhafter Kauf",
  signature: "Monatliche Unterschrift",
  signatureano: "Jahresabonnement",
  male: "Männlich ",
  female: "Fraulich",
  ambos: "Beide ",
  inicio9: "Hilfe",
  choosecategory: "Wählen Sie die Kategorie",
  categories: "Kategorien",
  light: "Leicht",
  preliminary: "Vorspiele",
  oral: "Mit Mund",
  anal: "Analsex",
  hot: "Heiß",
  extreme: "Extrem ",
  vd: "Wahrheit",
  dare: "Pflicht?",
  truth: "Wahrheit",
  time: "Zeit",
  createMyChallenges: "Meine Herausforderung erstellen",
  chosen: "Ausgewählt",
  text3: "Lass die Liebe in dich fließen!",
  text4: "Avatare zum Upgraden auswählen",
  close: "Schließen ",
  dev: "Entwickelt von Dev12BR",
  next: "WEITER",
  config3: "Keine Anzeigen",
  config4: "Avatare zum Upgraden auswählen",
  config9: "Erstellen und bearbeiten Sie Ihre eigenen Herausforderungen",
  version: "Premium-Version ",
  alert3: "Bitte wählen Sie mindestens eine Kategorie",
  tituloAlert1: "⚠️ Das Spiel fängt gleich an 😜",
  duvidas: "Fragen oder Vorschläge – Scharfe Herausforderungen",
  description: "Hallo, meine Frage oder Anregung ist: ",
  contact: " Kontakt",
  botaoApple: "Käufe wiederherstellen",
  alertCompra: "Ihr Kauf wird wiederhergestellt",
  NotPurchase: "Sie haben keine Käufe.",
  options: "Optionen",
  avalie: "Bewerten",
  novaCategoria: "Meine Kategorien",
  alterLanguage: "Sprache ändern?",
  textLanguage:
    "Wenn Sie eine neue Sprache auswählen, wird die Anwendung neu gestartet.",
  textLanguage1: "Sprache ändern",
  cancel: "Abbrechen",
  languages: "Sprachen",
  deletCat: "Kategorie löschen",
  textDeletCat:
    "Wenn Sie diese Kategorie löschen, werden die in dieser Kategorie vorhandenen Herausforderungen gelöscht. Nach dieser Aktion kann es nicht mehr rückgängig gemacht werden.",
  deletDes: "Herausforderung löschen",
  textDeletDes:
    "Nach dem Löschen der Herausforderung kann diese Aktion nicht mehr rückgängig gemacht werden.",
  desafio: "Neue Herausforderung registrieren",
  desafiotexto: "Herausforderung",
  textoeditDesafio: "Wer kann das tun?",
  textEmquem: "Wer ?",
  nome: "Name",
  inicio: "Fang an zu spielen",
  cadastrarCategory: "Neue Kategorie hinzufügen",
  inicio15: "Erstellen einer neuen Kategorie",
  inicio16:
    "Schritt 1: Drücke die Schaltfläche mit dem +-Zeichen unten auf diesem Bildschirm. Nach dem Drücken erscheint ein Fenster zur Eingabe Ihrer neuen Kategorie.",
  inicio17:
    "Schritt 2: Gebe Ihre neue Kategorie ein und klicke auf „Speichern“.",
  inicio18:
    "Schritt 3: Um diese Kategorie zu bearbeiten oder innerhalb der Kategorie HERAUSFORDERUNGEN HINZUZUFÜGEN, klicke darauf.",
  inicio19:
    "Schritt 4: Drücke auf dem nächsten Bildschirm die mit dem Pfeil ⬆️ gekennzeichnete Schaltfläche, um ein Fenster zum Bearbeiten Ihrer neuen Kategorie zu öffnen.",
  inicio20:
    "Schritt 5: Drücke auf dem nächsten Bildschirm auf die Schaltfläche mit dem Pfeil ⬆️, um die Kategorie zu löschen.",
  inicio21:
    "Schritt 1: Drücke die Schaltfläche unten, um eine neue Herausforderung zu dieser Kategorie hinzuzufügen ",
  inicio22: " Eine neue Herausforderung erstellen",
  inicio23:
    "Schritt 2: Klicke auf jedes eingekreiste Element, um die einzelnen Registrierungsfelder im Detail zu erfahren ",
  inicio24: "Herausforderungstext ",
  inicio25: ` Schreibe die Herausforderung nach Ihren Wünschen und drücke einfach den roten Knopf unten, damit der Name des Spielers in der Herausforderung angezeigt wird.
    
Es werden die folgenden Zeichen {nome} hinzugefügt.

** ÄNDERN SIE DIESE ZEICHEN NICHT ** Damit der Name entsprechend angezeigt wird, muss er wie unten beschrieben sein ⬇️⬇️⬇️⬇️

Herausforderung: Küsse {nome}s Hals`,
  inicio26: " Wer kann, wer kann empfangen?",
  inicio27: ` Wähle „Beide“, wenn die Herausforderung von Teilnehmern „beider“ Geschlechter durchgeführt und empfangen werden kann.
  
Sollte sich die Herausforderung an ein Geschlecht richten, wähle einfach das gewünschte aus.`,
  inicio28: "Hinzufügen von Zeit zur Herausforderung ",
  inicio29:
    "Falls Ihre Herausforderung eine Zeit hat, ziehe einfach den „Bereich“ darunter, und der Wert wird oben angezeigt. Nachdem der Timer in der Herausforderung abgelaufen ist, ertönt ein Ton, der das Ende der Herausforderung ankündigt.",
  aviso12: `Hier legst du nur die Kategorie an!
    
Um die Herausforderung hinzuzufügen, drücke einfach auf die Schaltfläche deiner gerade erstellten Kategorie ⬆️⬆️⬆️⬆️ `,
  voltar: "Zurück",
  semDe: "Spieler ohne Herausforderungen",
  semDe2: ` Registriere mindestens eine Herausforderung für diesen Spieler 😬.
  
Du wirst zum Anmeldebildschirm weitergeleitet.`,
  term: "Datenschutz",
  Potitic: "Nutzungsbedingungen",
  adquirited: "Gekauft",
  config10: "Exklusive Kategorie",
  config11: "Über 800 neue Herausforderungen",
  camera: "Kamera",
  galery: "Galerie",
  avatar: "Avatare",
  image: "Bild",
  seletion: "Ausgewählt",
  editCategory: "Kategorie bearbeiten",
  frase1: "Haben Sie Spaß an den Herausforderungen?",
  frase2: "Wie wäre es, die Premium-Herausforderungen auszuprobieren?",
  //err texto
  errTexto:
    "Wenn Sie einen Übersetzungsfehler gefunden haben, korrigieren Sie den Satz bitte in dem unten stehenden Feld:",
  errTitulo: "Ist dir etwas falsch aufgefallen?",
  errCorrect: "Wie wäre es auf Deutsch?",
  thisLanguageIsCorrect: "Ist die Herausforderung auf DEUTSCH korrekt?",
  yes: "Ja",
  no: "Nein",

  errSend: "Vorschlag senden",
  send: "Schicken",
  share: "Teilen",
  fraseShare: `Was für eine Spitzen-App! Ich teile es nur, weil ich weiß, dass es dir auch gefallen wird!
Lade es herunter und sag mir dann, ob es nicht doch zu gut ist lol...😉
  
  
Link zum Herunterladen: https://desafiospicantesapp.page.link/share-app`,
  bandeira: "🇩🇪",
  morePlayer: "Mit mehreren Spielern spielen?",
  players: "Spieler",
  carregar: "Bild hochladen",
  takePhoto: "Ein Bild aufnehmen oder ein Bild auswählen",
  useAvatar: "Oder Avatare verwenden",

  hetero: "Heterosexuell",
  gay: "Schwul",
  lesbico: "Lesbisch",

  nomeHomem1: "Name des Mannes",
  nomeHomem2: "Name des Mannes",
  nomeMulher1: "Name der Frau",
  nomeMulher2: "Name der Frau",
  messageErr: "Hinzufügen der Spieler 🙌",
  descricaoErr: "Geben Sie die Namen der Teilnehmer ein ✍️",
  why: "Sagen Sie uns warum...",
  later: "Später bewerten",
  txtCard1: "Sie sind dran 🔥",
  txtCard2: "Lass es geschehen 😘",
  txtCard3: "Auf geht's! 😜",
  txtCard4: "Nächste Herausforderung 😈",
  txtCard5: "Noch eine! 👄",

  tituloBloco1Novo: "Entdecken Sie die sexuelle Intimität mit Ihrem Partner",
  subtitulo1Novo: "Mehr als 1 Million glückliche Paare",
  texto1Novo:
    "Entdecken Sie die Intimität zwischen Ihnen und Ihrem Partner und greifen Sie auf die besten Spiele für Paare zu! Schalten Sie jetzt alle Spiele mit verschiedenen Kategorien frei, die für Sie entwickelt wurden, um die Verbindung mit Ihrer Liebe zu verbessern!",

  tituloBloco2Novo: "Neue Erfahrungen und eine bessere Beziehung",
  texto2Novo1: "Genießen Sie mehr als 1500 Herausforderungen",
  texto2Novo2: "Erstellen Sie Ihre eigenen Herausforderungen",
  texto2Novo3: "Exklusive Kategorien",
  texto2Novo4: "Keine Anzeigen",
  texto2Novo5: "Exklusive Avatare",
  texto2Novo6: "Jeden Tag neue Herausforderungen",
  texto2Novo7: "Regelmäßig aktualisierte Spiele",
  tituloBloco3Novo: "Höchste Bewertung in der Kategorie",
  tituloBloco4Novo: "Vorteile für Ihre Beziehung:",
  texto4Novo1: "Intimität",
  texto4Novo2: "Begehren",
  texto4Novo3: "Leichtigkeit",
  texto4Novo4: "Anziehung",
  texto4Novo5: "Verbindung",
  texto4Novo6: "Vergnügen",

  tituloBloco5Novo: "Was Paare sagen",
  texto5depoimentoTitulo1: "Blade Moody",
  texto5depoimento1: `Ich denke, dass dies die beste App ist, die ich bisher auf dem Handy gefunden habe, da sie erotisch und interessant ist. Alle anderen Apps, die ich gesehen habe, können nicht mithalten, deshalb sollten Sie sich beeilen und sie kaufen. Beschweren Sie sich nicht, weil Sie pleite sind. Sie verpassen einige wirklich gute Dinge hier und können die ganze App für 10$ erwerben. Es bietet bessere Erfahrungen als Spiele, die man in den örtlichen Erotikläden bekommt.`,
  texto5depoimentoTitulo2: "Joon Rxs",
  texto5depoimento2:
    "Diese App ist fantastisch! Ich war mir nicht sicher, ob ich es herunterladen sollte, aber es war sicherlich das beste Gefühl, das wir in letzter Zeit hatten. Wie gut ist es zu wissen, dass wir noch viele Dinge gemeinsam tun können. 🤭 Wir haben die kostenpflichtige Version getestet und sie ist es wirklich wert, wir hatten noch nicht diesen Grad an Lust erlebt.",
  texto5depoimentoTitulo3: "Monique SantosRader",
  texto5depoimento3:
    "Wenn Sie Ihre Beziehung aufpeppen wollen, ist diese App perfekt! Ich hatte schon andere getestet, aber keine hat uns so gut gefallen wie diese. Unser Vorspiel war viel heißer und lustvoller (stellen Sie sich jetzt den Rest vor!) Es lohnt sich wirklich, die kostenpflichtige Version zu kaufen (wenn Sie ein intensiveres Vergnügen empfinden wollen), aber auch die kostenlose Version hat uns überrascht.",
  texto5depoimentoTitulo4: "Anne owens",
  texto5depoimento4:
    "Ausgezeichnet! Wirklich sehr gut... Wir wurden während des Spiels sehr geil, was den Sex noch viel spannender machte, es war überall Lust! Wir freuen uns schon darauf, wieder zu spielen 💦🔥 wir empfehlen auch die kostenpflichtige Version, wenn ihr mit dem geilen Zeug umgehen könnt 🤤",

  tituloBloco6Novo:
    "Machen Sie es wie Hunderte von Paaren auf der ganzen Welt und peppen Sie Ihre Beziehung auf. Entdecken Sie mehr als 800 neue Herausforderungen!",
  texto6Select: "Wählen Sie die Version:",
  texto6Premium: "Premium",
  texto6Assinatura: "Abonnement",
  texto6Mensal: "Monatlich",
  texto6Anual: "Jährlich",
  texto6Vitalicia: "Lebenslange Lizenz",
  bePremium: "Werden Sie Premium",
  buyNew: "Kaufen",
  attention: "Achtung!",
  changeGender: "Sie haben Ihre sexuelle Orientierung geändert",

  tituloAvaliacao: "Spaß am Spiel?",
  textoAvaliacao: "Bewerte es und hilf uns, weiter zu verbessern!",
  agoraNão: "Jetzt nicht",
  enviarAvaliacao: "Senden",

  nomeJogo1: "Sexspiele für Paare",
  nomeJogo2: "Wahrheit oder Pflicht!",
  nomeJogo3: "Sündhaftes Niveau",
  nomeJogo4: "Freches Roulette",
  nomeJogo5: "Spruch des Tages",

  playAlone: "Alleine spielen",
  estaSozinho: "Bist du alleine?",
  selectPlayer: "Spieler auswählen",
  naughtyQuiz: "Unanständiges Quiz",

  skip: "Überspringen",
  responder: "Senden",
  respondaAqui: "Hier antworten",
  config4: "Wählen Sie Avatare zur Anpassung",

  tituloSelect1: "Alleine spielen?",
  tituloSelect2: "Beantworte pikante Fragen!",

  subTituloSelect1: "Wir geben dir eine Hand!",
  subTituloSelect2: "Finde heraus, wie frech du bist!",
  txtJogador1:
    "Wähle deinen Spieler aus und erkunde geführte Solo-Freuden, die nur für dich entworfen wurden!",
  txtJogador2: "Der ausgewählte Spieler wird die Fragen beantworten",
  tituloCena: "WELCHE GEGENSTÄNDE MÖCHTEST DU VERWENDEN?",
  subTituloCena:
    "Du hast keine? Tippe auf 'Erhalten' und erwerbe sie im Partnershop.",
  play: "Spielen",

  titleUserWarning: "Benutzer auswählen",
  txtUserWarning: "Wähle einen Benutzer aus, um die Fragen zu beantworten",

  shareNivelDeSafadeza:
    "Hey, schau dir mein Frechheitsniveau an 😈 Erlebe intensive Vergnügungsmomente. Versuche es auch 💋 Lade jetzt die App herunter und bereite dich auf heiße Herausforderungen 🔥 mit deinem Partner vor!: ➡️ https://desafiospicantesapp.page.link/sharelevelhot",

  shareDica:
    "Verwandeln Sie Ihr Liebesleben jetzt sofort! Laden Sie die App herunter und entdecken Sie das Geheimnis einer würzigen Beziehung: ➡️ https://desafiospicantesapp.page.link/tipoftheday",
  resultadoQuiz1:
    "Du bist eine zurückhaltende Person, magst die Schärfe nicht so sehr und ziehst etwas Romantisches vor!",
  resultadoQuiz2:
    "Du bist zu romantisch, um die Schärfe auszunutzen, und genießt mehr das Kerzenlicht.",
  resultadoQuiz3:
    "Du bist eine ziemlich reservierte Person und glaubst daran, die Dinge im Intimen diskret und privat zu halten.",
  resultadoQuiz4:
    "Das bedeutet nicht, dass du nicht manchmal frech bist, aber du ziehst es vor, all dieses Feuer für jemanden ganz Besonderen aufzubewahren.",
  resultadoQuiz5:
    "Deine Hitze ist im Hintergrund, aber das ändert nichts daran, dass es Hitze gibt!",
  resultadoQuiz6:
    "Du probierst gerne neue Erfahrungen aus, aber immer mit Respekt und Zustimmung.",
  resultadoQuiz7:
    "Du liebst ein heißes Date, voller Küsse und Leidenschaft. Es gibt jedoch auch eine Seite an dir, die es genießt, einen Film zu schauen und dabei die Hand deines Crushes zu halten oder bei Kerzenschein zu Abend zu essen.",
  resultadoQuiz8:
    "Du bist bereit, neue und aufregende Dinge auszuprobieren, aber immer verantwortungsbewusst.",
  resultadoQuiz9:
    "Du bist eine gewagte Person und würzt das Intime hin und wieder gerne auf.",
  resultadoQuiz10:
    "Du genießt alle Freuden des Lebens und kennst keine Grenzen, wenn es um Sex geht.",
  resultadoQuiz11:
    'Mit dir gibt es keine schlechte Zeit, und immer ist Zeit für ein kleines Abenteuer! Romantische Filme? Nur, wenn es "50 Shades of Grey" ist!',
  resultadoQuiz12:
    "Für dich ist die Intimität ein ständiges Abenteuer, und du hast keine Angst, Risiken einzugehen.",

  mes: "Monat",
  desafiosRestantesDois: "Du hast noch 2 Premium-Herausforderungen!",
  nenhumDesafioRestante: "Keine Premium-Herausforderungen mehr übrig!",
  tornePremiumAviso1:
    "Werde jetzt Premium und genieße 1000 exklusive Herausforderungen!",
  tornePremiumAviso2:
    "Genieße unbegrenzte Herausforderungen, exklusive Inhalte und ununterbrochenen Spaß!",
  conteudoPremium: "Du hast Premium-Inhalte ausgewählt!",
  aproveite4desafios:
    "Genieße 4 Premium-Herausforderungen, um exklusives Vergnügen zu erleben.",

  calculando: "Ergebnisse werden berechnet...",
  nivelRomantismo: "Dein Romantiklevel ist...",
  finalizar: "Fertigstellen",
  erroQuizTitulo: "Geben Sie Ihre Antwort ein",
  erroQuizFrase: "Um fortzufahren, geben Sie Ihre Antwort ein!",
  new: "Neue App",

  //resposta quiz safadeza
  resQuiz1: "Sanft",
  resQuiz2: "Leidenschaftlich",
  resQuiz3: "Charmant",
  resQuiz4: "Super frech",

  texto6Semanal: "Wöchentlich",
  weekly: "Wöchentliche Unterschrift",

  tempSemanal: "Wöchentlich abgerechnet",
  tempMensal: "Monatlich abgerechnet",
  tempAnual: "Jährlich abgerechnet",
  tempSempre: "Einmalzahlung",
  canceleAny: "Jederzeit stornierbar",

  //Tela do safadrometro
  Low: "Niedrig",
  Medium: "Mittel",
  High: "Hoch",
  lifeTime: "Lebenslanger Zugang",
  notNow: "Nicht jetzt, danke",
  match: "SPIEL MIT A.I.",

  dateTitle: "Möchtest du unsere neue App ausprobieren?",

  dateBody:
    "Möchtest du mit frechen 😈 Bots chatten und dein Flirten üben? Es wird Spaß machen!🔥",
  goToDate: "Probiere Date.AI jetzt aus!",

  goodForU: "WAS ES GUT FÜR DICH?",
  rateOurPerformance: "Bewerten Sie unsere Leistung bis hierher",
  veryGood: "Sehr gut",
  veryBad: "Sehr schlecht",
  feedbackChallenge:
    "Was würde Sie dazu bringen, die Hot Challenges-App mit anderen Paaren zu teilen und warum?",
  type: "Geben Sie Ihren Text hier ein...",
  survey: "Zufriedenheitsumfrage.",
  shareIfConfortable:
    "Fühlen Sie sich frei, es mit Freunden zu teilen, wenn Sie sich wohl fühlen :)",

  howToPlay: "Wie man spielt",
  howToPlayHotChallenge:
    "Mach dich bereit, die Dinge aufzupeppen! Zieh eine Herausforderungskarte und überrasche deinen Partner mit einer heißen Aktion!",

  preGameTip1:
    "Entfesseln Sie Ihre Wünsche und schaffen Sie unvergessliche Momente mit Ihrem Partner!",
  preGameTip2:
    "Entfachen Sie Ihre Leidenschaft und schaffen Sie unvergessliche Momente zusammen!",
  preGameTip3:
    "Erforschen Sie Ihre wildesten Wünsche und schaffen Sie unvergessliche Erinnerungen!",
  preGameTip4: "Lass deine Fantasien frei und genieße Momente purer Lust!",
  selecionajoagador: "Zeit zu spielen",
  dica: "Tipp",

  howToPlayNaughty:
    "Wähle deine Lieblingsspielzeuge und -objekte. Dreh das Rad und lass das Schicksal deine nächste freche Herausforderung bestimmen!",
  howToPlayTruthOrDare:
    "Wähle dein Schicksal: Teile eine Wahrheit oder stelle dich einer gewagten Herausforderung. Lass den Spaß beginnen!",
  howToKama1: "Entdecke Lustvolle Stellungen – 365 Tage Leidenschaft!",
  howToKama2:
    "Ziehe eine zufällige Karte, probiere die Stellung aus und entdeckt gemeinsam neue Höhen der Lust!",
  kamaExplain:
    "Schalte jeden Tag eine neue Stellung frei und baue deine ultimative Sammlung der Leidenschaft auf – deine Reise zu 365 Tagen unvergesslichen Vergnügens beginnt hier!",
  howToDo: "Wie es geht",
  pergunta: "Frage",

  restart: "Neustart",
  dialogText1HotChallenges:
    "Du hast alle verfügbaren Herausforderungen mit den ausgewählten Kategorien abgeschlossen.",
  dialogText2HotChallenges:
    "Wähle mehr Kategorien oder starte das Spiel mit den aktuellen Herausforderungen neu!",
  noChallenges: "Keine Herausforderungen!",

  objects: "Objekte",
  dialogText1NaughtyGames:
    "Du hast alle verfügbaren Herausforderungen mit den ausgewählten Objekten abgeschlossen.",
  dialogText2NaughtyGames:
    "Wähle mehr Objekte aus oder starte das Spiel mit den aktuellen Herausforderungen neu!",
  unlockPremium: "Premium Freischalten",

  noCategory: "Bitte wählen Sie mindestens eine Kategorie, um zu beginnen.",
  thanksForFeedback: "Danke, dass Sie uns helfen, das Erlebnis zu verbessern!",
  categoryKamasutra: "Wähle deine Leidenschaft und spiel!",
  tap: "Tippe, um deine Position zu enthüllen!",
  step: "Schritt-für-Schritt-Anleitung",
  shareQuizButton: "Teile dein freches Level!",
  tryAgain: "Versuche es erneut",
  unlockAllFun: "Entsperre den ganzen Spaß",
  limitedOffer: "Sonderangebot für begrenzte Zeit!",
  fill: "Geben Sie Ihren Namen und den Namen Ihres Partners oder Ihrer Partnerin ein.",
  kamaNotificationTitle: "🔥 Deine neue Karte ist freigeschaltet!",
  kamaNotificationBody:
    "Deine Position für Tag {variavel} ist bereit. Wie wäre es, heute etwas Neues auszuprobieren? 💋",

  titleNewGame: "Bereite dich auf das Rollenspiel vor!",
  phraseNewGame:
    "In der nächsten Aktualisierung kommt ein neues Spiel, um deine kreativsten Fantasien zu erkunden. Wähle Charaktere, erschaffe Geschichten und bringe den Spaß mit deinem Partner auf ein neues Level. 🔥",
  awaitNewGame: "Warte ab und mach dich bereit für einzigartige Momente!",
  selectObjects:
    "Wähle zwei oder mehr Gegenstände, um dein Spiel zu personalisieren. Erkunde alles bis zum Maximum.",
  soon: "Demnächst",
  wantToBeNotify: "Ich möchte benachrichtigt werden.",
  ok: "OK",
  vezDe: "DREHEN",

  categoryLabel: "Kategorie",
  descriptionLabel: "Beschreibung",

  loginConnect: "Anmelden",
  loginNoAccount: "Haben Sie kein Konto?",
  loginCreateNow: "Jetzt erstellen",
  loginOrConnect: "oder verbinden mit",

  email: "E-Mail",
  password: "Passwort",
  loginRegister: "Registrieren",
  loginAlreadyHas: "Haben Sie schon ein Konto?",
  enterNow: "Jetzt eintreten",

  logout: "Abmelden",
  customerPortal: "Kundenportal",
  installApp: "App installieren",

  loginVideo:
    "https://desafios-picantes-bucket.dev12br.com/videos-login/alemao.mp4",
};
